import React from 'react';

const NoSSR = (props) => {
    return window && window.toString() === '[object Window]' ? <>{props.children}</> : null;
};

NoSSR.displayName = 'NoSSR';

export default NoSSR;
